var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsa = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5207_29876)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.17389 7.4995H15C15 6.82257 14.9097 6.16679 14.7416 5.54297H7.17389V7.4995Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.17389 3.58739H13.8992C13.4401 2.83821 12.853 2.17602 12.1686 1.63086H7.17389V3.58739Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.49999 14.9996C9.2651 14.9996 10.8875 14.3895 12.1686 13.3691H2.83136C4.11251 14.3895 5.73489 14.9996 7.49999 14.9996Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.10079 11.4136H13.8992C14.2678 10.8121 14.5536 10.1547 14.7416 9.45703H0.258362C0.44636 10.1547 0.732209 10.8121 1.10079 11.4136Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.47414 1.17123H4.15761L3.52187 1.6331L3.76471 2.38043L3.12899 1.91856L2.49328 2.38043L2.70305 1.73481C2.1433 2.20107 1.6527 2.74734 1.2484 3.35602H1.46739L1.06271 3.65001C0.999668 3.75519 0.939199 3.86203 0.88125 3.97046L1.07449 4.56522L0.713965 4.30327C0.624346 4.49314 0.542373 4.68729 0.468691 4.88549L0.681592 5.5408H1.46739L0.83165 6.00267L1.07449 6.75L0.438779 6.28813L0.0579785 6.56481C0.0198633 6.8712 0 7.18327 0 7.5H7.5C7.5 3.35789 7.5 2.86957 7.5 0C6.0184 0 4.63726 0.429785 3.47414 1.17123ZM3.76471 6.75L3.12899 6.28813L2.49328 6.75L2.73612 6.00267L2.10038 5.5408H2.88618L3.12899 4.79347L3.37181 5.5408H4.15761L3.52187 6.00267L3.76471 6.75ZM3.52187 3.81788L3.76471 4.56522L3.12899 4.10335L2.49328 4.56522L2.73612 3.81788L2.10038 3.35602H2.88618L3.12899 2.60868L3.37181 3.35602H4.15761L3.52187 3.81788ZM6.45492 6.75L5.81921 6.28813L5.1835 6.75L5.42634 6.00267L4.7906 5.5408H5.5764L5.81921 4.79347L6.06202 5.5408H6.84782L6.21208 6.00267L6.45492 6.75ZM6.21208 3.81788L6.45492 4.56522L5.81921 4.10335L5.1835 4.56522L5.42634 3.81788L4.7906 3.35602H5.5764L5.81921 2.60868L6.06202 3.35602H6.84782L6.21208 3.81788ZM6.21208 1.6331L6.45492 2.38043L5.81921 1.91856L5.1835 2.38043L5.42634 1.6331L4.7906 1.17123H5.5764L5.81921 0.423896L6.06202 1.17123H6.84782L6.21208 1.6331Z",
  fill: "#0052B4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5207_29876"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsa);
export { ForwardRef as ReactComponent };